<template>
  <div class="videos-grid">
    <!-- Processing Placeholder -->
    <VideoItem v-if="hasAnyProcessingItem" :item="currentProcessingItem" :is-processing="true" @play="handlePlay" @download="handleDownload" />

    <!-- Video History Items -->
    <VideoItem v-for="(item, index) in videoHistory" :key="`history-${item.id || index}`" :item="item" @play="handlePlay" @download="handleDownload" />

    <!-- Create New Video Placeholder -->
    <div v-if="showCreatePlaceholder" class="video-placeholder create-placeholder" @click="$emit('create-new')">
      <div class="placeholder-content">
        <div class="placeholder-icon-container">
          <q-icon name="add" size="24px" />
        </div>
        <div class="placeholder-text">Create new video</div>
      </div>
    </div>

    <!-- Fill remaining grid slots -->
    <div v-for="n in emptySlots" :key="`placeholder-${n}`" class="video-placeholder"></div>
  </div>
</template>

<script>
import VideoItem from './VideoItem.vue';

export default {
  name: 'VideoGrid',
  components: {
    VideoItem
  },
  props: {
    videoHistory: {
      type: Array,
      default: () => []
    },
    hasAnyProcessingItem: {
      type: Boolean,
      default: false
    },
    currentProcessingItem: {
      type: Object,
      default: null
    },
    showCreatePlaceholder: {
      type: Boolean,
      default: false
    },
    isGenerating: {
      type: Boolean,
      default: false
    }
  },
  emits: ['play', 'download', 'create-new'],
  computed: {
    emptySlots() {
      const totalItems = this.videoHistory.length + (this.hasAnyProcessingItem ? 1 : 0) + (this.showCreatePlaceholder ? 1 : 0);
      return Math.max(0, 9 - totalItems);
    }
  },
  methods: {
    handlePlay(item, event) {
      this.$emit('play', item, event);
    },
    handleDownload(videoUrl) {
      this.$emit('download', videoUrl);
    }
  }
};
</script>

<style lang="scss" scoped>
.videos-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-top: 10px;
  height: calc(100vh - 200px);
  overflow-y: auto;
  align-content: start;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }
}

.video-placeholder {
  border: 1px solid var(--grey-hr);
  border-radius: 8px;
  background: var(--secondary-bg-color);
  position: relative;
  height: 230px;
  display: flex;
  align-items: center;
  justify-content: center;

  &.create-placeholder {
    border: 2px dashed var(--grey-hr);
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      border-color: var(--border-outlined-btn-color);
      background-color: rgba(254, 203, 47, 0.02);
    }
  }
}

.placeholder-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;

  .placeholder-icon-container {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: var(--main-bg-color);
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 12px;
  }

  .placeholder-text {
    @include inter-font($size: 12px, $bolded: false, $color: var(--secondary-text-color), $weight: 400);
  }
}
</style>
